import { Box, LinearProgress, Typography } from "@mui/material";
import type { ComponentType } from "react";
import Lottie from "react-lottie";
import type { LottieProps } from "react-lottie";
import CharacterSvg from "../../ReusableComponents/SvgAndIcons/CharacterSvg";

/** react-lottie class typings are incompatible with React 18's Component type (refs). */
const LottieView = Lottie as unknown as ComponentType<LottieProps>;

interface Props {
  lottie: any;
  textOne?: string;
  textTwo?: string;
}

const LoadingAnimationWithProgress = ({ lottie, textOne, textTwo }: Props) => {
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: lottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Box>
      <Box sx={{ position: "relative" }}>
        <CharacterSvg />
        <Box
          sx={{
            position: "absolute",
            top: "30px",
            right: { md: "10px", lg: "10px", xl: "50px" },
          }}
        >
          <LottieView options={lottieOptions} height={80} width={80} />
        </Box>
        <Box
          sx={{
            width: "100%",
            position: "absolute",
            bottom: "35px",
            zIndex: -1,
          }}
        >
          <LinearProgress />
        </Box>
      </Box>
      <Typography variant="h3" sx={{ textAlign: "center" }}>
        {textOne ?? ""} <br />
        {textTwo ?? ""}
      </Typography>
    </Box>
  );
};

export default LoadingAnimationWithProgress;
